import { render, staticRenderFns } from "./MainPageComponents.vue?vue&type=template&id=7c508d68&"
import script from "./MainPageComponents.vue?vue&type=script&lang=js&"
export * from "./MainPageComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports